import { createContext } from "react";
import {
  ISkipOverallStatistics,
  IDriverSkipStatsResponse,
  ISkipHistoryResponse,
  ISkipReasonsBreakdownResponse,
} from "../../models/skip-analytics/response";
import { ISkipAnalyticsQuery, ISkipHistoryQuery } from "../../models/skip-analytics/query";

export interface IInternalState {
  loading: string[];
  overallStats: ISkipOverallStatistics | null;
  driversStats: IDriverSkipStatsResponse | null;
  skipHistory: ISkipHistoryResponse | null;
  reasonsBreakdown: ISkipReasonsBreakdownResponse | null;
  driversQuery: ISkipAnalyticsQuery;
  historyQuery: ISkipHistoryQuery;
}

export interface IExternalState extends IInternalState {
  actions: {
    getOverallStatistics: (from_date?: string, to_date?: string) => Promise<void>;
    getDriversSkipStats: () => Promise<void>;
    getDriverSkipHistory: (driverId: number) => Promise<void>;
    getReasonsBreakdown: (driver_id?: number) => Promise<void>;
    setDriversQuery: (query: ISkipAnalyticsQuery) => void;
    setHistoryQuery: (query: ISkipHistoryQuery) => void;
    reset: () => void;
  };
}

const defaultState: IExternalState = {
  loading: [],
  overallStats: null,
  driversStats: null,
  skipHistory: null,
  reasonsBreakdown: null,
  driversQuery: {
    page: 1,
    per_page: 10,
    keyword: "",
  },
  historyQuery: {
    page: 1,
    per_page: 10,
  },
  actions: {
    getOverallStatistics: async () => {},
    getDriversSkipStats: async () => {},
    getDriverSkipHistory: async () => {},
    getReasonsBreakdown: async () => {},
    setDriversQuery: () => {},
    setHistoryQuery: () => {},
    reset: () => {},
  },
};

const SkipAnalyticsContext = createContext<IExternalState>(defaultState);

export default SkipAnalyticsContext;
